var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('fragment',[_c('quill-editor',_vm._g(_vm._b({ref:"quillComponent",class:_vm.me.role === 'FOUR_NETWORK'
        ? 'quill-editor'
        : _vm.isLeads
        ? 'quill-editor-leads'
        : _vm.isDebate
        ? 'quill-editor-debate'
        : _vm.me.role === 'PARTICIPANT' &&
          _vm.me.medalBenefities.includes('ADVANCED_FORMATTING')
        ? 'quill-editor-ranking'
        : 'quill-editor-common',attrs:{"options":_vm.me.role === 'FOUR_NETWORK'
        ? _vm.editorOption
        : _vm.isLeads
        ? _vm.editorOptionLeads
        : _vm.me.role === 'PARTICIPANT' &&
          _vm.me.medalBenefities.includes('ADVANCED_FORMATTING')
        ? _vm.editorOptionRanking
        : _vm.editorOptionCommon},on:{"change":_vm.updateMentionList,"ready":_vm.onEditorReady}},'quill-editor',[_vm.$attrs, _vm.$props],false),_vm.$listeners)),(_vm.showEmojiPicker)?_c('Picker',{staticClass:"quill-emoji-picker",style:(_vm.emojiPickerStyle),attrs:{"show-preview":false,"disable-skin-tones":true,"i18n":_vm.emojiI18n},on:{"select":_vm.addEmoji}}):_vm._e(),(_vm.showGifPicker)?_c('GifPicker',{staticClass:"quill-gif-picker",style:(_vm.gifPickerStyle),on:{"select":_vm.insertGif,"api-unavailable":_vm.onGifApiUnavailable}}):_vm._e(),(_vm.classQuill)?_c('div',{staticClass:"redAlert--text body-2",domProps:{"innerHTML":_vm._s(_vm.$t('post.limitCaracter'))}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }